import { get } from 'lodash';

import { ActualContainerItem, ContextualNotesSchemaResourceComplex, Item, OwnerInstitutionResource, TranslatedString, getTranslatedString } from '@skinsoft/types';

// Selectors for Item type

export const id = (item: Item) => get(item, 'id');

export const type = (item: Item) => {
    return get(item, 'entityType') ?? get(item, 'type')
}

export const manifestation = (item: Item) => {
    return get(item, 'linkToManifestation.referentManifestation.ref') ??
        get(item, 'linkToManifestation.referentManifestation')
}

export const permanentLocation = (item: Item) => {
    const res = get(item, 'locationItemSchema.permanentLocation.permanentLocation')
    return (res as any)?.ref ?? res
}

export const realTimeLocation = (item: Item) => {
    const res = get(item, 'locationItemSchema.realTimeLocation.realTimeLocation')
    return (res as any)?.ref ?? res
}

export const futureLocation = (item: Item) => {
    const res = get(item, 'locationItemSchema.futureLocation.futureLocation')
    return (res as any)?.ref ?? res
}

export const title = (item: Item, locale: string) => getTranslatedString(get(item, 'translatedTitle', ''), locale) as string || get(item, 'title');

export const creationDate = (item: Item) => get(item, 'descriptionWorkSchema.creationDates[0].date.dateFIAF', '')

export const institution = (item: Item) => get(item, 'institutionCreation')

export const ownerInstitutions = (item: Item): OwnerInstitutionResource[] | null | undefined => {
    return get(item, 'juridicalItemSchema.ownerInstitutions')
}

export const inventoryNumber = (item: Item) => {
    const res = get(item, 'identificationWorkSchema.identifiers[0].identifier') 
        ?? get(item, 'identificationItemSchema.identifiers[0].identifier')

    return (res as any)?.value ?? res
}

export const lastDateOfConditionReport = (item: Item) => get(item, 'stateItemSchema.lastDateOfConditionReport')

export const lastConditionReport = (item: Item): string | undefined | null => {
    return get(item, 'lastConditionReport')
}

export const identifier = (item: Item, locale: string) => {
    const barCode = get(item, `identificationItemSchema.barCodes.translatedString.${locale}`);

    const uniqueIdentifier = get(item, 'identificationItemSchema.identifiers[0].identifier');

    let res = uniqueIdentifier || barCode || "..."

    if((res as any).value) {
        return (res as any).value
    }

    return res
};

export const notesOnIdentification = (item: Item): ContextualNotesSchemaResourceComplex[] => {
    return get(item, 'contextualNotesSchema.notesOnIdentification', [])
}

export const actualContainers = (item: Item): ActualContainerItem[] | undefined | null => {
    return get(item, 'conditioningItemSchema.actualContainer')
}

export const conditioningMaterial = (item: Item, locale: string): string => {
    const translatedString: TranslatedString | undefined | null = get(
        item, 
        'safetyPlanSchema.conditioningMaterial'
    )

    if(translatedString) {
        return getTranslatedString(translatedString, locale)
    }

    return ''
}

export const media = (item: Item) => {
    const otherMedia = get(item, 'associatedMedias.mediaFiles.0.mediaId', null);
    const third = get(item, 'associatedMedias.third');
    const second = get(item, 'associatedMedias.second');
    const first = get(item, 'associatedMedias.first');
    const res = first || second || third || otherMedia;

    return res?.ref ?? res
}

// federated schema
export const federatedTitle = (item: Item, locale: string): string => {
    const translatedString = get(item, 'federatedSchema.titles[0]')

    if(translatedString) {
        return getTranslatedString(translatedString, locale) ?? ""
    }

    return ""
}

export const federatedTitles = (item: Item): TranslatedString[] => {
    return get(item, 'federatedSchema.titles', [])
} 


